export const PrismicError = () => {
  return <div className="tw-bg-red-600">{'!Error!'}</div>;
};
